module.exports = "<template> <sio-html config.bind=field></sio-html> </template> ";